import { RegularInterviewCreateCommand } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { FormContextValues } from '@dreryk/react-common';
import { ModalConfirmButton } from '@dreryk/react-components';
import { Choice } from '@dreryk/watermelon';

import { gynecologicalInterviewTranslationKeys } from '../../translations';

type GynecologicalInterviewRegularInterviewCreateSubmitValues = {
   description: string | null;
};

type GynecologicalInterviewRegularInterviewCreateActionProps = {
   readonly handleSubmit: FormContextValues<GynecologicalInterviewRegularInterviewCreateSubmitValues>['handleSubmit'];
   readonly medicalInformationId: number;
   readonly patientId: number;
   readonly onSuccess: VoidFunction;
};

export const GynecologicalInterviewRegularInterviewCreateAction = (
   props: GynecologicalInterviewRegularInterviewCreateActionProps
): JSX.Element => {
   const { executeAsync: createRegularInterview } = useCqrsCommand<
      void,
      GynecologicalInterviewRegularInterviewCreateSubmitValues
   >(
      (parameters) => {
         const command = new RegularInterviewCreateCommand();
         command.patientId = props.patientId;
         command.description = Choice.withUseDefaultIfNull(parameters.description ?? null);
         command.medicalInformationId = props.medicalInformationId;
         return command;
      },
      {
         onSuccess: props.onSuccess,
      }
   );

   return (
      <ModalConfirmButton
         testId={'createRegularInterview'}
         label={gynecologicalInterviewTranslationKeys.addEntry}
         onClick={props.handleSubmit(createRegularInterview)}
      />
   );
};
